/* 南方洋行 · 帳場バー（sections/nanpo-header.liquid）
   - 东京时间 + 受付状态（平日 open–close 点为受付中）。页面上所有 [data-nhh-status] 都会更新，页脚也用它
   - 滚动：.is-scrolled；底部墨线按阅读进度伸长（--p）
   - Search：主栏下方的大字搜索栏；点外面或 Esc 关闭
   - Menu（手机）：整屏墨色菜单，锁滚动，焦点留在菜单里，Esc 关闭；窗口变宽到桌面尺寸时自动关
   - 下拉（电脑，10/9）：鼠标移入打开、移出稍等再关；键盘移到栏目上打开，焦点离开就关；
     触屏第一次点只打开，第二次点才进栏目页；Esc、点外面、打开搜索时关闭 */
class NhHeader extends HTMLElement {
  connectedCallback() {
    this.openH = parseInt(this.dataset.open || '10', 10);
    this.closeH = parseInt(this.dataset.close || '17', 10);
    this.searchPanel = this.querySelector('.nhh__search');
    this.menuPanel = this.querySelector('.nhh__menu');

    this.tick();
    this.timer = setInterval(() => this.tick(), 20000);

    this.onScroll = this.onScroll.bind(this);
    addEventListener('scroll', this.onScroll, { passive: true });
    addEventListener('resize', this.onScroll, { passive: true });
    this.onScroll();

    this.querySelectorAll('[data-nhh-search-toggle]').forEach(b => b.addEventListener('click', () => this.toggleSearch()));
    this.querySelectorAll('[data-nhh-menu-toggle]').forEach(b => b.addEventListener('click', () => this.toggleMenu()));
    if (this.menuPanel) this.menuPanel.querySelectorAll('a').forEach(a => a.addEventListener('click', () => this.toggleMenu(false)));
    this.drops = [...this.querySelectorAll('[data-nhh-drop]')];
    this.drops.forEach(item => this.initDrop(item));

    this.onKey = this.onKey.bind(this);
    this.onDocClick = this.onDocClick.bind(this);
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('click', this.onDocClick);

    this.desktop = matchMedia('(min-width: 990px)');
    this.onBreakpoint = () => { if (this.desktop.matches) this.toggleMenu(false); };
    this.desktop.addEventListener('change', this.onBreakpoint);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    removeEventListener('scroll', this.onScroll);
    removeEventListener('resize', this.onScroll);
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('click', this.onDocClick);
    this.desktop.removeEventListener('change', this.onBreakpoint);
    document.documentElement.classList.remove('nhh-lock');
  }

  tick() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short'
    }).formatToParts(new Date());
    const get = t => (parts.find(p => p.type === t) || {}).value || '';
    const wd = get('weekday');
    const h = parseInt(get('hour'), 10) % 24;
    const open = !['Sat', 'Sun'].includes(wd) && h >= this.openH && h < this.closeH;
    const clock = `TOKYO ${String(h).padStart(2, '0')}:${get('minute')} · ${wd.toUpperCase()}`;
    const state = open ? this.dataset.openText : this.dataset.closedText;
    document.querySelectorAll('[data-nhh-status]').forEach(s => {
      s.classList.toggle('is-open', open);
      s.querySelectorAll('[data-nhh-clock]').forEach(c => { c.textContent = clock; });
      s.querySelectorAll('[data-nhh-state]').forEach(c => { c.textContent = state; });
    });
  }

  onScroll() {
    if (this.raf) return;
    this.raf = requestAnimationFrame(() => {
      this.raf = null;
      const y = scrollY;
      this.classList.toggle('is-scrolled', y > 8);
      const max = document.documentElement.scrollHeight - innerHeight;
      this.style.setProperty('--p', max > 0 ? Math.min(1, y / max).toFixed(4) : '0');
    });
  }

  initDrop(item) {
    const a = item.querySelector('.nhh__cell--drop');
    let timer, tapOpen = false;
    item.addEventListener('mouseenter', () => { clearTimeout(timer); this.toggleDrop(item, true); });
    item.addEventListener('mouseleave', () => { timer = setTimeout(() => this.toggleDrop(item, false), 160); });
    item.addEventListener('focusin', () => { clearTimeout(timer); this.toggleDrop(item, true); });
    item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) this.toggleDrop(item, false); });
    // 触屏：按下时还没打开，就把这次点击当作「打开」，不跳页
    a.addEventListener('pointerdown', e => { tapOpen = e.pointerType !== 'mouse' && !item.classList.contains('is-open'); });
    a.addEventListener('click', e => {
      if (!tapOpen) return;
      tapOpen = false;
      e.preventDefault();
      this.toggleDrop(item, true);
    });
  }

  toggleDrop(item, open) {
    if (open) this.drops.forEach(d => { if (d !== item) this.toggleDrop(d, false); });
    item.classList.toggle('is-open', open);
    const a = item.querySelector('.nhh__cell--drop');
    if (a) a.setAttribute('aria-expanded', String(open));
  }

  onKey(e) {
    if (e.key === 'Escape') {
      const open = this.drops.find(d => d.classList.contains('is-open'));
      if (open) {
        const back = open.contains(document.activeElement);
        this.toggleDrop(open, false);
        if (back) open.querySelector('.nhh__cell--drop').focus({ preventScroll: true });
      }
      this.toggleSearch(false, true);
      this.toggleMenu(false);
      return;
    }
    // 菜单打开时，Tab 在菜单内部循环
    if (e.key === 'Tab' && this.menuPanel && !this.menuPanel.hidden) {
      const f = [...this.menuPanel.querySelectorAll('a[href], button, input')].filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  onDocClick(e) {
    if (this.searchPanel && !this.searchPanel.hidden && !this.contains(e.target)) this.toggleSearch(false);
    this.drops.forEach(d => { if (!d.contains(e.target)) this.toggleDrop(d, false); });
  }

  toggleSearch(force, restoreFocus) {
    const p = this.searchPanel;
    if (!p) return;
    const open = typeof force === 'boolean' ? force : p.hidden;
    if (open === !p.hidden) return;
    p.hidden = !open;
    if (open) this.drops.forEach(d => this.toggleDrop(d, false));
    this.querySelectorAll('[data-nhh-search-toggle][aria-expanded]').forEach(b => b.setAttribute('aria-expanded', String(open)));
    if (open) {
      const input = p.querySelector('input[type="search"]');
      if (input) input.focus();
    } else if (restoreFocus) {
      const btn = this.querySelector('.nhh__tool--search');
      if (btn) btn.focus({ preventScroll: true });
    }
  }

  toggleMenu(force) {
    const p = this.menuPanel;
    if (!p) return;
    const open = typeof force === 'boolean' ? force : p.hidden;
    if (open === !p.hidden) return;
    p.hidden = !open;
    document.documentElement.classList.toggle('nhh-lock', open);
    this.querySelectorAll('[data-nhh-menu-toggle][aria-expanded]').forEach(b => b.setAttribute('aria-expanded', String(open)));
    if (open) {
      this.toggleSearch(false);
      const close = p.querySelector('.nhh__menu-close');
      if (close) close.focus();
    } else {
      const btn = this.querySelector('.nhh__menu-btn');
      if (btn && btn.offsetParent !== null) btn.focus({ preventScroll: true });
    }
  }
}
if (!customElements.get('nh-header')) customElements.define('nh-header', NhHeader);
